// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2rPeh","insightsList":"newBusinessInsightsMenu_insightsList__3MYgw","active":"newBusinessInsightsMenu_active__1iXFi"};